export default [
  {
    id: 1,
    image: 'https://images.unsplash.com/photo-1479064555552-3ef4979f8908?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80',
    name: 'Men Collection',
    price: 15000,
    summary: 'A custom made outfit for men out there',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic quibusdam accusamus vero culpa, consequatur dolores. Quasi voluptatem, facilis sapiente veritatis voluptates quae hic consectetur eaque',
    inFavorites: false,
    quantity: 1,
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1495121605193-b116b5b9c5fe?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=388&q=80',
    name: 'Summer Oufit',
    price: 8000,
    summary: 'Best outfit during the summers',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic quibusdam accusamus vero culpa, consequatur dolores. Quasi voluptatem, facilis sapiente veritatis voluptates quae hic consectetur eaque',
    inFavorites: false,
    quantity: 1,
  },
  {
    id: 3,
    image: 'https://images.unsplash.com/photo-1554412933-514a83d2f3c8?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=372&q=80',
    name: 'Night Gear',
    price: 10000,
    summary: 'Perfect for night family events',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic quibusdam accusamus vero culpa, consequatur dolores. Quasi voluptatem, facilis sapiente veritatis voluptates quae hic consectetur eaque',
    inFavorites: false,
    quantity: 1,
  },
  {
    id: 4,
    image: 'https://images.unsplash.com/photo-1552374196-1ab2a1c593e8?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80',
    name: 'Austin Wades',
    price: 20000,
    summary: 'Good looking male outfit',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic quibusdam accusamus vero culpa, consequatur dolores. Quasi voluptatem, facilis sapiente veritatis voluptates quae hic consectetur eaque',
    inFavorites: false,
    quantity: 1,
  },
  {
    id: 5,
    image: 'https://images.unsplash.com/photo-1568306281824-7afe898030d1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=385&q=80',
    name: 'Red Suit',
    price: 15000,
    summary: 'Outfit for the super stylist male',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic quibusdam accusamus vero culpa, consequatur dolores. Quasi voluptatem, facilis sapiente veritatis voluptates quae hic consectetur eaque',
    inFavorites: false,
    quantity: 1,
  },
  {
    id: 6,
    image: 'https://images.unsplash.com/photo-1583778477928-531a25a0baf2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80',
    name: 'Colored Girl',
    price: 26000,
    summary: 'Beautiful and Sparkling outfit dress',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic quibusdam accusamus vero culpa, consequatur dolores. Quasi voluptatem, facilis sapiente veritatis voluptates quae hic consectetur eaque',
    inFavorites: false,
    quantity: 1,
  },
];
